import script from "./AddAccidentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAccidentModal.vue?vue&type=script&setup=true&lang=js"

import "./AddAccidentModal.vue?vue&type=style&index=0&id=669bba06&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669bba06"]])

export default __exports__